// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"80142f8a","766":"ecea5b9b"}[chunkId] + ".chunk.js";
};